import { makeStyles } from "@material-ui/core/styles";
import { Field, FieldProps, Form, Formik } from "formik";
import { FormikHelpers } from "formik/dist/types";
import { MessageThread } from "interfaces/front/business";
import { ValidationErrorV2 } from "lib/service/BaseClientService";
import { ContactMessage, FrontMessageService, PostContactMessageQuery } from "lib/service/client/FrontMessageService";
import { infoToast } from "lib/toast";
import { useRouter } from "next/router";
import React, { FC } from "react";
import * as Yup from "yup";

const service = new FrontMessageService();
type PostMessageFormProps = {
  messageThread: MessageThread;
  onSuccess: (message: ContactMessage) => void;
};
export const PostContactMessageForm: FC<PostMessageFormProps> = (props: PostMessageFormProps) => {
  const router = useRouter();
  const classes = useStyles();
  return (
    <Formik<PostContactMessageFields>
      initialValues={{
        message: "",
      }}
      validationSchema={Yup.object().shape({
        message: Yup.string().trim().required("必須項目です").max(2000, "2000文字以下にしてください"),
      })}
      onSubmit={async (values: PostContactMessageFields, helpers: FormikHelpers<PostContactMessageFields>): Promise<void> => {
        const setValidationError = (validationError: ValidationErrorV2): void => {
          helpers.setErrors(validationError);
        };
        const query = { contact_message_thread_id: props.messageThread.id, message: values.message };
        await service.postContactMessage(query, router, setValidationError, (contactMessage: ContactMessage) => {
          helpers.resetForm();
          infoToast("メッセージを投稿しました。");
          props.onSuccess(contactMessage);
        });
        helpers.setSubmitting(false);
      }}
    >
      {({ errors, touched, isSubmitting }): React.ReactNode => (
        <Form>
          {touched.message && errors.message && (
            <p className={`form_template_area_block--error ${classes.errorMessage}`}>{errors.message}</p>
          )}
          <div className="mypage_content_message_chat_field">
            <Field name={"message"}>
              {({ field }: FieldProps<string>): React.ReactNode => (
                <div className="mypage_content_message_chat_field_input">
                  <div className="mypage_content_message_chat_field_input_bg" />
                  <textarea placeholder={"メッセージを入力する…"} {...field} />
                </div>
              )}
            </Field>
            <div className="mypage_content_message_chat_field_submit">
              <div className="mypage_content_message_chat_field_submit_bg" />
              <input disabled={isSubmitting} value="メッセージを送信" type="submit" />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

type PostContactMessageFields = Omit<PostContactMessageQuery, "contact_message_thread_id">;

const useStyles = makeStyles((theme) => ({
  errorMessage: {
    marginBottom: "5px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
  },
}));
